// ignore-string-externalization

import React from 'react';
import qs from 'query-string';
import { CSSProperties } from 'styled-components';
import { ImageAspectBox16x9 } from './Box';

type VideoType = {
  url: string;
  wrapper?: boolean;
  width?: string;
  height?: string;
  iframeStyle?: CSSProperties;
  wrapperStyle?: CSSProperties;
};

export const VideoComponent: React.FC<VideoType> = ({
  url = '',
  wrapper = true,
  width,
  height,
  iframeStyle,
  wrapperStyle = {},
}) => {
  function videoId(videoUrl: string): string | null {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = videoUrl.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  }

  const embedUrl: string = `https://www.youtube.com/embed/${videoId(
    url,
  )}?${qs.stringify({
    autoplay: 0,
    iv_load_policy: 3,
    playsinline: 1,
    rel: 0,
    showinfo: 0,
  })}`;

  const params = {} as any;
  if (width) params.width = width;
  if (height) params.height = height;
  if (iframeStyle) params.style = iframeStyle;

  const frame = (
    <iframe
      title="video"
      src={embedUrl}
      frameBorder="0"
      allowFullScreen
      allow="encrypted-media"
      {...params}
    />
  );

  if (wrapper) {
    return (
      <ImageAspectBox16x9 data-testid="video-component" style={wrapperStyle}>
        {frame}
      </ImageAspectBox16x9>
    );
  }

  return frame;
};
